import {
    AccountInfo,
    AuthenticationResult,
    AuthenticationScheme,
    Configuration,
    PublicClientApplication,
    SilentRequest,
    SsoSilentRequest
} from "@azure/msal-browser";

// Must match FAKE_USER in e2e/scrub.ts, the identity the recorded API responses use.
const FAKE_ACCOUNT: AccountInfo = {
    homeAccountId: "e2euser.e2e-tenant",
    environment: "login.microsoftonline.com",
    tenantId: "72f988bf-86f1-41af-91ab-2d7cd011db47",
    username: "e2euser@microsoft.com",
    localAccountId: "e2euser",
    name: "E2E Test User"
};

const fakeResult = (scopes: string[] = []): AuthenticationResult => ({
    authority: "https://login.microsoftonline.com/common",
    uniqueId: FAKE_ACCOUNT.localAccountId,
    tenantId: FAKE_ACCOUNT.tenantId,
    scopes,
    account: FAKE_ACCOUNT,
    idToken: "e2e-id-token",
    idTokenClaims: {},
    accessToken: "e2e-access-token",
    fromCache: true,
    expiresOn: new Date(Date.now() + 60 * 60 * 1000),
    tokenType: AuthenticationScheme.BEARER,
    correlationId: "e2e"
});

/**
 * MSAL client for the Playwright smoke tests (`e2e/`): always signed in as a fake account and returns a fake token, so the
 * shell loads without a real sign-in. Only the `e2e` app setting (`build/app.settings.js`) turns it on, and the tests
 * replay recorded API responses, so the token never reaches a real server.
 */
export class FakePublicClientApplication extends PublicClientApplication {
    public constructor(configuration: Configuration) {
        super(configuration);
    }

    public override handleRedirectPromise(): Promise<AuthenticationResult | null> {
        return Promise.resolve(null);
    }

    public override getAllAccounts(): AccountInfo[] {
        return [FAKE_ACCOUNT];
    }

    public override getActiveAccount(): AccountInfo | null {
        return FAKE_ACCOUNT;
    }

    public override setActiveAccount(): void {
        // The fake account is always active.
    }

    public override acquireTokenSilent(request: SilentRequest): Promise<AuthenticationResult> {
        return Promise.resolve(fakeResult(request.scopes));
    }

    public override ssoSilent(request: SsoSilentRequest): Promise<AuthenticationResult> {
        return Promise.resolve(fakeResult(request.scopes));
    }
}

export const isE2EFakeAuth = () => process.env.E2E_FAKE_AUTH === "true";
